import { render, staticRenderFns } from "./IndexPc.vue?vue&type=template&id=857f68f6&scoped=true&"
import script from "./IndexPc.vue?vue&type=script&lang=js&"
export * from "./IndexPc.vue?vue&type=script&lang=js&"
import style0 from "./IndexPc.vue?vue&type=style&index=0&id=857f68f6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f68f6",
  null
  
)

component.options.__file = "IndexPc.vue"
export default component.exports